define(function (require) {

	// templates
	const tpl = require('./t_cpv_ss_list.hbs');
	// views
	const itemView = require('./v_itv_ss_item');
	//const emptyView = require('./v_itv_instrument_list_empty');

	return Marionette.CompositeView.extend({

		template: tpl,
		//emptyView: emptyView,
		childView: itemView,
		events: {

		},

		ui: {
		},
		childViewContainer: function () {
			// The target (in the composite view) for the item rows
			return '.list-container'
		},
		childViewOptions: function (model, index) {
			return {
				readOnlyIcons:this.readOnlyIcons
			}
		},
		filter: function (child, index, collection) {
			//filter out any sites that don't match our primary setting - don't show the primary site in additional sites section and vice a versa
			return (child.get('primarySite') === true) == this.options.isPrimarySiteView;
		},
		initialize: function (options) {
			this.readOnlyIcons = options.readOnlyIcons;
		},
		onRender: function () {

		},
		templateHelpers: function () {
			//get the number of sites being displayed in this view
			let numberSitesToDisplay = this.collection.filter((item)=>{
				return (item.get('primarySite') === true ) == this.options.isPrimarySiteView;
			}).length;
			return {
				headerText: ()=>{
					let headerText = 'Primary Site';
					if(!this.options.isPrimarySiteView){
						headerText = numberSitesToDisplay > 1 ? 
							i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.ADDITIONAL_SITES') : 
							i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.ADDITIONAL_SITE')
					}
					return headerText;
				},
				hiddenCSSClass: numberSitesToDisplay > 0 ? '' : ' hidden'
			}	
		}
	});
});
